/* eslint-disable */
const videoSamples = (hallazgosMonitoreo, hallazgos) => 
{
  const resultado = [];
  if (hallazgosMonitoreo !== null && hallazgosMonitoreo !== undefined) 
  {
    // Ordenar los hallazgos por pk que se registro en el monitoreo previamente
    hallazgosMonitoreo?.sort((a, b) => a.pk - b.pk);

    // Ordenar las muestras por id dentro de cada hallazgo que se registro en el monitoreo previamente
    hallazgosMonitoreo.forEach((hallazgo) => {
      if (hallazgo?.muestras?.length > 0) {
        hallazgo.muestras.sort((a, b) => a.pk - b.pk);
      }
    });
    hallazgos.forEach((hallazgo) => {
      const hallazgoMonitoreo = hallazgosMonitoreo.find((hm) => hm.pk === hallazgo.pkHallazgo);
      if (hallazgoMonitoreo && hallazgoMonitoreo?.muestras?.length > 0) {
        const muestrasNo = hallazgoMonitoreo.muestras.filter((m) => m.muestra === 'No');
        muestrasNo.forEach((muestra) => {
          const hallazgoMuestra = hallazgo.muestras.find((m) => m.pkMuestra === muestra.pk);
          if (hallazgoMuestra) {
            resultado.push({
              pkMuestra: hallazgoMuestra.pkMuestra,
              idMuestra: muestra.id,
              idHallazgo: hallazgoMonitoreo.id,
              muestra: hallazgoMuestra.muestra
            });
          }
        });
      }
    });
  }

  return resultado;
};

const splitBase64 = (base64String, partSize) => {
  const parts = [];
  for (let i = 0; i < base64String.length; i += partSize) {
    parts.push(base64String.slice(i, i + partSize));
  }
  return parts;
};

export { videoSamples, splitBase64 };
